import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Stack } from '@mui/material';

import { List, NoStoresFound, SizingMultiplier } from '@ocx/ui';
import { LocationIcon } from '@ocx/ui-icons';
import { useShowGenericErrorSnackbar } from '@ocx-app/hooks/useShowGenericErrorSnackbar';

import { useLocalOffersLocationSelector } from './use-local-offers-location-selector.hook';
import { SearchField } from './search-field';
import { LocalOffersLocationListItem } from './local-offers-location-list-item';
import { LocalOffersLocationSelectorPageLayout } from './local-offers-location-selector.page.layout';
import { messages } from './store-locator.messages';

export const LocalOffersLocationSelectorPageController = () => {
  const showGenericErrorSnackbar = useShowGenericErrorSnackbar();

  const {
    loading,
    googleMapsApiKey,
    stores,
    handleLocationSelect,
    marketingTitle,
    noResults,
    handleCurrentLocationClick,
    onSearchSubmit,
  } = useLocalOffersLocationSelector({
    onCoordinatesNotFound: showGenericErrorSnackbar,
    onSearchError: showGenericErrorSnackbar,
  });

  const intl = useIntl();

  const searchField = googleMapsApiKey ? (
    <SearchField googleMapsApiKey={googleMapsApiKey} onSearchSubmit={onSearchSubmit} />
  ) : undefined;

  const useCurrentLocationItem = useMemo(
    () => ({
      uuid: 'use-current-location-button',
      title: intl.formatMessage(messages['localOffers:useMyCurrentLocation:buttonTitle']),
      subtitle: intl.formatMessage(messages['localOffers:useMyCurrentLocation:buttonSubtitle'], {
        marketingTitle,
      }),
    }),
    [intl, marketingTitle],
  );

  return (
    <LocalOffersLocationSelectorPageLayout isLoading={loading}>
      <Stack spacing={SizingMultiplier.md}>
        {searchField}
        <List hideDivider spacing={SizingMultiplier.md}>
          {stores.length ? (
            stores.map((item) => (
              <LocalOffersLocationListItem key={item.uuid} item={item} onClick={handleLocationSelect} />
            ))
          ) : (
            <LocalOffersLocationListItem
              item={useCurrentLocationItem}
              onClick={handleCurrentLocationClick}
              Icon={LocationIcon}
            />
          )}

          {noResults && <NoStoresFound open />}
        </List>
      </Stack>
    </LocalOffersLocationSelectorPageLayout>
  );
};
